module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"support_urgency":{"label":"Urgência","LOW":"Baixa","NORMAL":"Normal","HIGH":"Alta","URGENT":"Urgente"}},"en":{"support_urgency":{"label":"Urgency","LOW":"Low","NORMAL":"Normal","HIGH":"High","URGENT":"Urgent"}}}')
  delete Component.options._Ctor
}
